import { useSocket } from 'socket.io-react-hook';

export const useGetAppSocket = () => {
  const socket = useSocket(
    import.meta.env.VITE_APP_SOCKETS_URL, { multiplex: false, withCredentials: true, autoConnect: true }
  );

  return socket;
};
